<template lang="html">
  <v-container>
    <v-row>
      <v-col xs12 md8 v-if="$store.state.User.recently_active_user.length === 0">
        <v-card>
          <h1>No user invites here...</h1>
        </v-card>
      </v-col>
      <v-col xs12 md8 v-if="$store.state.User.recently_active_user.length > 0">
        <StandardDialog v-if="show_dialog" @click-outside="show_dialog=false">
          <template #content>
            <StandardTextCard
              height="74vh"
              :name="'USER.activities'"
              :clickable="false"
            >
              <template #info>
                <h2>{{dialog_user.first_name}} {{dialog_user.last_name}} <small>{{dialog_user.email}}</small></h2>
                <h3>Projects</h3>
                <div>
                  <v-card
                    v-for="(p, index) in $store.state.User.user_activites[dialog_user.id].projects" :key="`projects${index}`"
                    class="user-search-card"
                  >
                    <b>{{p.project}}</b> <br>
                    <i>{{p.prole}}</i>
                  </v-card>

                </div>
                <div class="user-search-flex-clear"></div>
                <h3>Logentries</h3>
                <div
                v-for="(l, index) in $store.state.User.user_activites[dialog_user.id].logentries" :key="`logentries${index}`"
                class="user-search-loglist">
                  <StandardDataField
                  class="pa-1 user-search-loglist-color"
                  :header="`${dialog_user.first_name} ${l.created.substring(0, 16)} (${l.project_name})`"
                  :value="l.target === 'comment'?
                  l.value:
                  `${l.target} ${$t('Home.UserHome.Loglist.ActionSeperator')} ${l.action}`"

                  :readonly="true"
                  width="100%"
                  :style="`overflow: hidden ;text-overflow: ellipsis;
                  white-space: nowrap; max-height: 45px;
                  width: '100%';
                  `"
                  text_color="primary"
                  />
                </div>
                <div class="user-search-flex-clear"></div>
                <h3>Invites</h3>
                <div
                v-for="(i, index) in $store.state.User.user_activites[dialog_user.id].invites" :key="`invites${index}`"
                class="user-search-loglist">
                  <StandardDataField
                  class="pa-1 user-search-loglist-color"
                  :header="`${i.created.substring(0, 16)} (${i.status})`"
                  :value="`Invited by ${i.issuer} to ${i.project.name} as ${i.prole}`"
                  :readonly="true"
                  width="100%"
                  :style="`overflow: hidden ;text-overflow: ellipsis;
                  white-space: nowrap; max-height: 45px;
                  width: '100%';
                  `"
                  text_color="primary"
                  />
                </div>
                <div class="user-search-flex-clear"></div>
                <h3>Sequences</h3>
                <div
                v-for="(s, index) in $store.state.User.user_activites[dialog_user.id].sequences" :key="`sequences${index}`"
                class="user-search-loglist">
                  <StandardDataField
                  class="pa-1 user-search-loglist-color"
                  :header="`${s.updated.substring(0, 16)} (updated)`"
                  :value="`${s.name}`"
                  :readonly="true"
                  width="100%"
                  :style="`overflow: hidden ;text-overflow: ellipsis;
                  white-space: nowrap; max-height: 45px;
                  width: '100%';
                  `"
                  text_color="primary"
                  />
                </div>
                <div class="user-search-flex-clear"></div>
                <h3>Workpackages</h3>
                <div
                v-for="(w, index) in $store.state.User.user_activites[dialog_user.id].workpackages" :key="`workpackages${index}`"
                class="user-search-loglist">
                <StandardDataField
                class="pa-1 user-search-loglist-color"
                :header="`${w.updated.substring(0, 16)} (updated)`"
                :value="`${w.name} [${w.token}]`"
                :readonly="true"
                width="100%"
                :style="`overflow: hidden ;text-overflow: ellipsis;
                white-space: nowrap; max-height: 45px;
                width: '100%';
                `"
                text_color="primary"
                />
              </div>
              <div class="user-search-flex-clear"></div>

              </template>
              <template #actions>
                <v-btn :disabled="!dialog_user.verified" color="red" text @click="deactivateUser({
                  id: dialog_user.id,
                  is_search: true
                }), dialog_user.verified = !dialog_user.verified">Deactivate user</v-btn>
                <v-btn :disabled="dialog_user.verified" color="green" text @click="reactivatedUser({
                  id: dialog_user.id,
                  is_search: true
                }), dialog_user.verified = !dialog_user.verified">Reactivate user</v-btn>
                <v-btn color="grey" text @click="show_dialog=false">Cancel</v-btn>
              </template>
            </StandardTextCard>
          </template>
        </StandardDialog>
        <v-data-table
          :headers="headers"
          :items="$store.state.User.recently_active_user"
          :sort-by="[]"
          :sort-desc="[false, true]"
          multi-sort
          single-select
          class="elevation-1"
        >
          <template v-slot:item.copy="{ item }">
            <v-tooltip
              :open-on-hover="false"
              bottom
            >
              <template #activator="{ on }">
                <v-icon
                  medium
                  class="mr-2"
                  :disabled="!hasPermission('User READ ALL')"
                  @click="on.click"
                  @blur="on.blur"
                  @click.native="copyEmail(item.email)"
                >
                  content_copy
                </v-icon>
              </template>
              <span>Copied Email to clipboard</span>
            </v-tooltip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              medium
              class="mr-2"
              :disabled="!hasPermission('User READ ALL')"
              @click="requestUserActivites(item.id).then(() => {
                dialog_user = JSON.parse(JSON.stringify(item));
                show_dialog = true;
                })"
            >
              information
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue';
import StandardTextCard from '@/components/StandardComponents/StandardTextCard.component.vue';
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue'
import { mapActions, mapGetters } from 'vuex';
import store from '@/store/index';
export default {
  name: 'UserInvites',
  components: { StandardDialog, StandardTextCard, StandardDataField },
  beforeRouteEnter (to, from, next) {
    store.dispatch('User/requestRecentlyActiveUser').then(res => next(res));
  },
  data: function () {
    return {
      show_dialog: false,
      dialog_user: {},
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Email', value: 'email' },
        { text: 'Copy Email to Clipboard', value: 'copy' },
        { text: 'First name', value: 'first_name' },
        { text: 'Last name', value: 'last_name' },
        { text: 'Created', value: 'created' },
        { text: 'Last Active', value: 'updated' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  computed: {
    // ...mapGetters('User', [
    //   'requestRecentInvitedUser'
    // ]),
    ...mapGetters('Auth', [
      'hasPermission'
    ])
  },
  methods: {
    ...mapActions('User', [
      'deactivateUser',
      'reactivatedUser',
      'requestUserActivites',
    ]),
    copyEmail(email){
      navigator.clipboard.writeText(email);
    },
  }
}
</script>

<style lang="css" scoped>
.user-search-flex-clear{
  clear: both;
}
.user-search-card {
  height: 75px;
  width: 150px;
  margin: 5px;
  float: left;
  padding: 5px;
}
.user-search-loglist {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 3px 3px 0px 3px;
  cursor: pointer;
  float: left;
  width: 30%;
}
.user-search-loglist-color {
  background-color: var(--v-color-5-base);
  width: 100%;
}
.user-search-loglist-wrapper {
  /* width: 500px; */
}
</style>
